import { NgModule, inject } from '@angular/core';

import {
  VshcDialogModule,
  ZefAuthModule,
  ZefWebsocketModule,
  ZefMetaModule,
  ZefNgrxRouterModule,
  ZefSnackErrorModule,
  ZefErrorsModule,
  ZefAuthRefreshTokenModule,
  ZefEntitiesModule,
  ZefPopErrorModule,
  ZefProgressModule,
  ZefFormsModule,
  ZefRecaptchaModule,
  HttpStatusCodes,
  META_CONFIG,
  CollectionManagerService
} from '@vshosting/core';
import { environment } from '@vshosting/cdn/env';
import { ApiEntityKeys } from '../../app.constant';

@NgModule({
  imports: [
    ZefEntitiesModule.forRoot({
      config: {
        apiPrefix: '/api'
      }
    }),
    ZefRecaptchaModule.forRoot(),
    // !!! keep order of AuthRefresh, Auth and Error imports
    // needed for the correct interceptor chain
    ZefAuthRefreshTokenModule,
    ZefErrorsModule.forRoot({
      // we don't want to show 401 error, as it always
      // triggers refresh, which either successes and
      // "nothing" visible happens for the user
      blacklistedErrors: [ HttpStatusCodes.UNAUTHORIZED ]
    }),
    ZefFormsModule.forRoot(),
    ZefProgressModule.forRoot(),
    ZefAuthModule.forRoot({
      loginEndpoint: `${environment.authApiUrl}/login`,
      logoutEndpoint: `${environment.authApiUrl}/logout`,
      refreshEndpoint: `${environment.authApiUrl}/refresh`
    }),
    ZefNgrxRouterModule.forRoot(),
    ZefWebsocketModule.forRoot({
      loginUrl: environment.websocketAuthUrl,
      apiUrl: environment.websocketApiPath,
      host: environment.websocketHost,
      forceSecuredEndpoint: true,
      pingPongEnabled: true
    }),
    VshcDialogModule.forRoot(),
    ZefPopErrorModule,
    ZefSnackErrorModule,
    ZefMetaModule.forRoot(),
  ],
  providers: [
    {
      provide: META_CONFIG,
      useValue: {
        baseTitle: 'vshosting CDN',
        separator: '~'
      }
    },
  ]
})
export class ZefLibModule {

  #collectionManagerService = inject(CollectionManagerService);

  constructor() {
    this.#collectionManagerService.create({
      [ApiEntityKeys.User]: {
        definitions: {
          clientUserList: [ ApiEntityKeys.ClientUser ]
        }
      },
      [ApiEntityKeys.Domain]: {},
      [ApiEntityKeys.DataDomain]: {},
      [ApiEntityKeys.ClientUser]: {},
      [ApiEntityKeys.Alias]: {},
      [ApiEntityKeys.NodeTaskQueueConsolidated]: {}
    });
  }
}
